import LayoutSidebar from "./LayoutSidebar.vue";
import SearchResultsHeader from "@/components/SearchResultsHeader/SearchResultsHeader.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import RelatedArticles from "@/components/RelatedArticles/RelatedArticles.vue";
import MentionedIn from "@/components/MentionedIn/MentionedIn.vue";
import Footer from "@/components/Footer/Footer.vue";
import MobileNav from "@/components/MobileNav/MobileNav.vue";
import { mapGetters } from "vuex";
import { adSubdomain } from "@/common/functions";
import { isSmallDevice } from "@/common/functions";
import Advertising from "@/components/Advertising/Advertising.vue";

export default {
    name: "LayoutSidebar",
    components: {
        Advertising,
        SearchResultsHeader,
        Sidebar,
        RelatedArticles,
        MentionedIn,
        Footer,
        MobileNav
    },
    data() {
        return {
            mobileNavIsOpen: false,
            layout: "LayoutSidebar",
            subdomain: adSubdomain(this.$route.meta.subdomain),
            searchResultHeaderClass: ""
        };
    },
    methods: {
        mobileMenuToggle(value) {
            this.mobileNavIsOpen = value;
        },
        isSmallDevice
    },
    computed: {
        ...mapGetters(["currentLanguage"])
    },
    created() {
        this.$parent.$emit("upadate:layout", LayoutSidebar);
    },
    mounted() {
        setTimeout(() => {
            this.searchResultHeaderClass = this.$refs["leaderboard-ad"].$el.offsetHeight
                ? "adblocked"
                : "";
        }, 1000);
    }
};



// WEBPACK FOOTER //
// ./src/layouts/LayoutSidebar/LayoutSidebar.js